import defaultSettings from '@/settings'
import store from '@/store'
import global from '@/global'

export default function getPageTitle(pageTitle, path) {
  const title = setPageTitle(path)
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}

function setPageTitle(path) {
  let title = ''
  try {
    // 避免出现一些错误导致网站都进不去
    path = path.split('/')
    const getTitle = (data) => {
      let title = ''
      global.modules.some(element => {
        if (element.value === data.toUpperCase()) {
          title = element.name
          return
        }
      })

      if (title === '') {
        title = getTitle(store.state.permission.routesType)
      }
      return title
    }
    title = getTitle(path[1])
  } catch (e) {
    title = defaultSettings.title || 'Vue Admin Template'
  }

  return title
}
